module.exports = __webpack_public_path__ + "static/media/thunderstorm-sun.4dfb7e21.svg";